/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
    i18n: {
        defaultLocale: "de",
        locales: ["en", "de"],
    },
    debug: process.env.NODE_ENV === "development",
    reloadOnPrerender: process.env.NODE_ENV === "development",
    serializeConfig: false, // avoids sending full config to client on every route for better performance
};
